<template>
  <b-row>
    <b-col cols="12" class="d-flex justify-content-end my-1">
      <b-button variant="primary" @click="$bvModal.show('add-feedback-modal')">
        Add Feedback
      </b-button>
    </b-col>

    <b-col md="2" sm="4" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage"
          :options="pageOptions.map(option => ({ text: option, value: option }))" size="sm" class="w-50" />

      </b-form-group>
    </b-col>
    <b-col md="10" class="my-1">
      <b-form-group label="Filter" label-cols-sm="8" label-align-sm="right" label-size="sm" label-for="filterInput"
        class="mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="searchQuery" @input="onSearch" type="search"
            placeholder="Type to Search" />
          <b-input-group-append>
            <b-button :disabled="!searchQuery" @click="searchQuery = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :items="filteredOpportunities" :fields="fields" :per-page="perPage"
        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" v-if="!loading">
        <template #cell(createdOn)="data">
          {{ formatDate(data.item.createdOn) }}
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="deleteFeedback(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loadingopp"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
          class="my-0"></b-pagination>
      </b-col>
    </b-col>



    <!-- Modal for add -->
    <b-modal id="add-feedback-modal" title="Add Feedback" @ok.prevent="onSubmit" @hidden="resetForm">
      <b-row>
        <b-col cols="12" class="mx-auto">
          <b-card title="Add Feedback" class="mb-3">
            <validation-observer ref="AddForm" #default="{ invalid }">
              <b-form @submit.prevent="onSubmit">
                <b-form-group label="Feedback Title:" label-for="feedback-title">
                  <validation-provider #default="{ errors }" name="Feedback Title" vid="Feedback Title"
                    rules="required">
                    <b-form-input id="name" type="text" v-model="form.title" required
                      placeholder="Feedback Title"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Feedback Description:" label-for="name">
                  <validation-provider #default="{ errors }" name="Feedback Description" vid="Feedback Description"
                    rules="required">
                    <b-form-textarea id="textarea-default" placeholder="Description" rows="3" v-model="form.description"
                      required />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" @click="onSubmit" :disabled="submitting">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Adding...' : 'Add' }}
        </b-button>
      </template>
    </b-modal>

    <b-modal id="edit-complaint-modal" title="Edit complaint" @ok.prevent="updatecomplaint">
      <b-row>
        <b-col cols="12" class="mx-auto">
          <b-card title="Add complaint" class="mb-3">
            <validation-observer ref="EditForm" #default="{ invalid }">

              <b-form @submit.prevent="updatecomplaint">

                <b-form-group label="Customer/Lead:" label-for="customer-lead">
                  <validation-provider #default="{ errors }" name="Customer/Lead" vid="Customer/Lead" rules="required">
                    <b-form-select v-model="editFormData.leadClientId" :options="optionsCustomer" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="complaint Name:" label-for="name">
                  <validation-provider #default="{ errors }" name="complaint Name" vid="complaint Name"
                    rules="required">
                    <b-form-input id="name" type="text" v-model="editFormData.title" required
                      placeholder="Enter complaint Name"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" @click="updatecomplaint" :disabled="submitting">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Editing...' : 'Edit' }}
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BTab,
  BTabs,
  BContainer,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BFormDatepicker,
  BInputGroupAppend,
  VBModal,
  BButton,
  BSpinner,
  BModal,
  BDropdown,
  BFormTextarea,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  components: {
    BTable,
    BAvatar,
    BForm,
    BTab,
    BTabs,
    BModal,
    BBadge,
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    VBModal,
    BFormInput,
    BFormDatepicker,
    BFormTextarea,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formState: {},
      id: this.$route.params.id,
      selectedStatus: null,
      loading: false,
      changingcomplaint: null,
      showModal: false,
      currentTab: 'All',
      searchQuery: '',
      pageOptions: [3, 5, 10],
      perPage: 5,
      sortBy: 'createdOn',  // This specifies the default sort column
      sortDesc: true,       // This specifies that the sorting should be in descending order
      fields: [
        { key: "title", label: "Feedback Title", sortable: true },
        { key: "description", label: "Description" },
        { key: "createdOn", label: "Added On", sortable: true, formatter: (value) => this.formatDate(value) },
        { key: "actions" },
      ],

      currentPage: 1,
      perPage: 5,
      form: {
        title: "",
        description: "",

      },
      editFormData: {
        title: "",
        description: "",
      },

      optionsCustomer: [],
      submitting: false,
    };
  },
  props: {
    complaint: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    rows() {
      return this.filteredOpportunities.length;
    },
    ...mapGetters("complaintModule", {
      feedback: "feedback",
      loadingopp: "loading",
    }),
    filteredOpportunities() {
      if (!this.searchQuery) {
        return this.feedback;
      }
      return this.feedback.filter((complaint) => {
        return Object.keys(complaint).some((key) => {
          return String(complaint[key]).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    },
    currentStatus() {
      const statusMapping = {
        0: 'All', // Representing all opportunities
        1: 'New',
        2: 'InProgress',
        3: 'ClosedWon',
        4: 'ClosedLost'
      };

      return statusMapping[this.currentTab];
    },
  },

  methods: {
    ...mapActions("complaintModule", ["addComplaintFeedbackAction", "getComplaintFeedbackAction", "deleteComplaintFeedbackAction"]),
    ...mapActions("leadModule", ["getLeadListAction"]),
    ...mapActions("customerModule", ["getCustomersListAction"]),

    resetForm() {
      this.form = {
        title: "",
        description: "",
      };
    },


    beautifyStatus(status) {
      return status
        .split(/(?=[A-Z])/)
        .join(' ')
        .trim();
    },


    prepareEditcomplaint(item) {
      this.editFormData = {
        title: item.title,
        description: item.description,
      };
      this.$bvModal.show('edit-complaint-modal');
    },


    promptChangeStatus(complaint) {
      this.changingcomplaint = complaint;
      this.selectedStatus = complaint.status;
      this.$bvModal.show("change-status-modal");
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleString("en-US", options);
    },
    async deleteFeedback(id) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this feedback!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      });

      if (result.isConfirmed) {
        this.$swal({
          title: 'Deleting...',
          text: 'Please wait while the feedback is being deleted...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        try {
          await this.deleteComplaintFeedbackAction(id);
          this.$swal.hideLoading();
          this.success("Feedback deleted successfully");
        } catch (error) {
          this.$swal.hideLoading();
          this.error("There was a problem deleting the feedback. Please try again.");
        } finally {
          this.$swal.close();
          await this.getComplaintFeedbackAction(this.id)
        }
      }
    },

    // Helper methods
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },


    async onSubmit() {
      this.submitting = true;
      const isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        try {
          const payload = {
            ...this.form,
            complaintId: this.id,
          };
          await this.addComplaintFeedbackAction(payload);
          this.success('Feedback added successfully!');
        } catch (error) {
          this.error("There was an error adding the Feedback, please try again later");
        } finally {
          this.submitting = false;
          this.$bvModal.hide("add-feedback-modal");
          this.resetForm();
          await this.getComplaintFeedbackAction(this.id)
        }
      } else {
        await this.getComplaintFeedbackAction(this.id)
        this.submitting = false;
      }
    }
  },

  async mounted() {
    await this.getComplaintFeedbackAction(this.id)
      .then((response) => {
      })
      .catch((response) => {
        console.log(response);
      });
  },


};
</script>